<template>
  <PageBase>
    <router-view />
  </PageBase>
</template>

<script>
import PageBase from "@/core/components/PageBase";

export default {
  name: "AffiliatePortalView",
  components: { PageBase },
};
</script>
